import { Controller } from '@hotwired/stimulus'
import { iframeResize } from 'iframe-resizer'

export default class extends Controller {
  static targets = ['heading', 'subtext', 'successIcon', 'widget']

  connect() {
    const params = new URLSearchParams(window.location.search)

    if (params.get('application') === 'true') {
      this.#showApply()
    } else if (params.get('subscription') === 'true') {
      this.#showSubscribe()
    } else if (params.has('appointment_type')) {
      this.#showWidget('appointmentType', params.get('appointment_type'))
    } else if (params.has('calendar_id')) {
      this.#showWidget('calendarID', params.get('calendar_id'))
    } else if (params.has('form_submission')) {
      this.#showConfirmation()
    }

    if (this.hasWidgetTarget) iframeResize({}, this.widgetTarget)
  }

  #showApply() {
    this.headingTarget.textContent = 'Thank you for applying.'
    this.subtextTarget.textContent = 'We will review your application shortly.'
  }

  #showConfirmation() {
    this.headingTarget.textContent = 'Form submitted successfully.'
    this.subtextTarget.remove()
    this.#showSuccessIcon()
  }

  #showSubscribe() {
    this.headingTarget.textContent = 'You have been successfully subscribed.'
    this.subtextTarget.remove()
    this.#showSuccessIcon()
  }

  #showSuccessIcon() {
    if (this.hasSuccessIconTarget) {
      this.successIconTarget.style.display = 'flex'
    }
  }

  #showWidget(type, param) {
    if (!this.hasWidgetTarget) return

    this.widgetTarget.src =
      `https://app.acuityscheduling.com/schedule.php?owner=11249458&${type}=${param}`
  }
}
